import { memo } from 'react'

export type ZoomControlsProps = {
  onZoomIn: () => void
  onZoomOut: () => void
  onReset?: () => void
}

function ZoomControlsComponent({ onZoomIn, onZoomOut, onReset }: ZoomControlsProps) {
  return (
    <div className="absolute right-6 bottom-6 z-50 flex flex-col items-center gap-2 text-white">
      <button
        type="button"
        onClick={onZoomIn}
        className="rounded-full bg-white/12 hover:bg-white/25 px-3 py-2 text-lg font-semibold shadow-xl border border-white/20 backdrop-blur"
      >
        +
      </button>
      <button
        type="button"
        onClick={onZoomOut}
        className="rounded-full bg-white/12 hover:bg-white/25 px-3 py-2 text-lg font-semibold shadow-xl border border-white/20 backdrop-blur"
      >
        –
      </button>
      {onReset && (
        <button
          type="button"
          onClick={onReset}
          className="mt-2 rounded-full bg-white/8 hover:bg-white/18 px-3 py-1 text-xs uppercase tracking-[0.18em] border border-white/15"
        >
          Reset
        </button>
      )}
    </div>
  )
}

export const ZoomControls = memo(ZoomControlsComponent)
